import $ from 'jquery';

/**
 * Navigation that regulates automatically the quantity of visible children links in it.
 * When resizing adjusting links quantity by moving them to the dropdown menu.
 *
 * Check out {@link https://getbootstrap.com/docs/4.0/components/dropdowns}
 * For required structure of the dropdown menu.
 *
 * !! Provisional naming
 */
export default class SmartNav {
  constructor() {
    const getFontSize = () => +getComputedStyle(document.documentElement).fontSize.slice(0, -2);
    const handleItems = ($nav) => {
      const $dropdown = $nav.children('.dropdown');
      const $dropdownMenu = $dropdown.children('.dropdown-menu');
      const fontSize = getFontSize();

      // Find out why finding the difference with only dropdown width it's not enough and remove multiplying
      let availableWidth = $nav.innerWidth() - ($dropdown.outerWidth() * 1.75);

      let isFull = false;
      let total = 0;

      // Moving items inside of drop-menu
      $nav.children(':not(.dropdown)').each(function () {
        const $link = $(this);
        const width = $link.data('ratio') * fontSize;

        if (!isFull && total + width >= availableWidth) {
          isFull = true;
        }
        if (isFull) {
          $link
            .data('classes', $link.attr('class'))
            .attr('class', '')
            .addClass('dropdown-item')
            .appendTo($dropdownMenu);

          if (!$dropdown.is(':visible')) {
            $dropdown.show();
            availableWidth -= $dropdown.outerWidth();
          }
        } else {
          total += width;
        }
      });

      // Moving items outside of drop-menu
      if (!isFull) {
        $($dropdownMenu.children().get().reverse()).each(function () {
          const $link = $(this);
          const width = $link.data('ratio') * fontSize;

          if (total + width >= availableWidth) {
            return false;
          }
          $link
            .removeClass('dropdown-item')
            .attr('class', $link.data('classes'))
            .insertBefore($dropdown);
          total += width;
          return true;
        });

        if ($dropdownMenu.children().length === 0) {
          availableWidth += $dropdown.outerWidth();
          $dropdown.hide();
        }
      }
    };

    // Initialization
    $('.smart-nav').each(function () {
      const fontSize = getFontSize();
      const $nav = $(this);

      // Hiding dropdown
      $nav.children('.dropdown').hide();

      // Saving ratio foreach link in menu
      $nav.children(':not(.dropdown)').each(function () {
        const $link = $(this);
        $link.data('ratio', $link.outerWidth() / fontSize);
      });

      // Attaching event
      $(window).resize(() => handleItems($nav));
      handleItems($nav);
    });
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/smart-nav.js